<template>
  <div class="app-container">
    <div
      ref="filterContainer"
      class="filter-container"
    >
      <!-- 后退、前进、设置列 -->
      <table-operation2
        :init-table-column="masterList.initTableColumn"
        :table-columns.sync="masterList.tableColumns"
        :table-key="masterList.tableKey"
        :table-index.sync="masterList.tableIndex"
        :search-condition.sync="masterList.tableQuery"
        :table-transfer-name="getTransferName()"
        :todo-list.sync="todoList"
        show-to-do
        @reloadData="requestData()"
        @todoDownloadDeclarationForm="handleDownloadDeclarationForm"
      />
    </div>
    <div class="container-box">
      <!-- 查询条件 -->
      <div ref="searchCondition">
        <el-row :gutter="10">
          <el-col style="width:40px; padding-left:10px;">
            <el-button type="text">
              查询：
            </el-button>
          </el-col>
          <el-col :span="3">
            <el-input
              v-model="masterList.tableQuery.schemeName"
              placeholder="请输入方案名称"
              style="width:100%"
              clearable
              @keyup.enter.native="searchData()"
            />
          </el-col>
          <el-col :span="3">
            <el-input
              v-model="masterList.tableQuery.schemeNo"
              placeholder="请输入方案编号"
              style="width:100%"
              clearable
              @keyup.enter.native="searchData()"
            />
          </el-col>
          <el-col :span="3">
            <el-input
              v-model="masterList.tableQuery.itemName"
              placeholder="请输入物料项目名称"
              style="width:100%"
              clearable
              @keyup.enter.native="searchData()"
            />
          </el-col>
          <el-col :span="3">
            <el-select
              v-model="masterList.tableQuery.provinceId"
              placeholder="请选择省区"
              clearable
              style="width:100%"
            >
              <el-option
                v-for="item in provinceOptions"
                :key="item.data"
                :label="item.label"
                :value="item.data"
              />
            </el-select>
          </el-col>
          <el-col :span="3">
            <date-select
              :search-date.sync="masterList.tableQuery.searchDate"
              placeholder="请选择开始日期"
            />
          </el-col>
          <el-col :span="3">
            <el-date-picker
              v-model="masterList.tableQuery.reportEndDate"
              type="date"
              style="width: 100%;"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              :editable="false"
              placeholder="请选择截止填报日期"
            />
          </el-col>
          <el-col :span="3">
            <el-button
              type="primary"
              @click="searchData()"
            >
              查询
            </el-button>
          </el-col>
        </el-row>
      </div>

      <!-- 数据列表 -->
      <custom-table2
        :ref="masterList.tableKey"
        style="margin-top:5px"
        :data-obj="masterList"
        :table-key="masterList.tableKey"
        :table-columns="masterList.tableColumns"
        :table-data="masterList.tableData"
        :loading="masterList.tableLoading"
        :search-condition.sync="masterList.tableQuery"
        :data-total="masterList.tableDataTotal"
        :table-contextmenu="masterList.tableContextmenu"
        :table-custom-height="tableHeight"
        :total-amount="totalAmount"
        :is-show-total="isShowTotal"
        is-index-field
        is-paging
        @reloadData="loadTableData()"
        @export="batchExport(masterList)"
        @getTotal="totalFun"
      />
    </div>

    <!-- 下载零星宣传物料制作申报审批表 -->
    <download-declaration-dialog
      :dialog-visible.sync="dialogDownloadVisible"
      @reloadData="loadTableData()"
    />
  </div>
</template>

<script>
// Table操作组件（后退、前进、列设置）
import TableOperation2 from '@/components/TableOperation2'
// 列表设置tableKeyMixin
import tableOperationMixin2 from '@/mixin/tableOperationMixin2'
// 自定义Table
import CustomTable2 from '@/components/CustomTable2'
// 定义表头颜色，高度，查询，获取数据Mixin
import tableCustomMixin2 from '@/mixin/tableCustomMixin2'
// 导出 batchExportMixin
import batchExportMixin2 from '@/mixin/batchExportMixin2'
// 日期选择
import DateSelect from '@/components/DateSelect';
// 下载物料制作申报审批表
import downloadDeclarationDialog from './components/downloadDeclarationDialog'
// 区域API
import { listAreaApi } from '@/api/v2/area';
// 方案服务项目API
import { loadSchemeServiceItemListDataApi, sumSchemeServiceItemListDataApi, exportSchemeServiceItemListDataApi } from '@/api/v2/schemeServiceItem';

export default {
  name: 'MaterialsSchemeServiceItem',
  components: {
    CustomTable2,
    TableOperation2,
    DateSelect,
    downloadDeclarationDialog
  },
  mixins: [tableCustomMixin2, tableOperationMixin2, batchExportMixin2],
  data () {
    return {
      // 主列表
      masterList: {
        initTableColumn: [], // Table初始化列
        tableColumns: [], // Table列
        tableKey: 'materials_scheme_service_item_master', // Table Key
        tableIndex: 0, // Table Index
        tableLoading: false, // Table加载状态
        tableData: [], // Table数据
        tableDataTotal: 0, // Table总数据条数
        // Table右键
        tableContextmenu: [
          {
            permissionSigns: ['scheme_service_item_export'],
            prop: 'export',
            label: '导出',
            method: 'export'
          }
        ],
        tableQuery: {
          // 页数
          page: 1,
          // 每页条数
          limit: 50,
          // 右键筛选字段
          contextMenuWrap: [],
          // 排序字段
          sortProp: '',
          // 排序类型
          sortOrder: '',
          // 查询条件
          schemeName: '',
          schemeNo: '',
          itemName: '',
          searchDate: '',
          schemeStatus: '',
          provinceId: '',
          reportEndDate: '',
          notSchemeStatus: 3,
          // 合计字段
          sumField: ''
        }
      },
      // 待办
      todoList: [
        // permissionSigns: ['scheme_service_item_download'],
        { label: '下载零星宣传物料制作申报审批表', method: 'todoDownloadDeclarationForm', count: 0 },
      ],
      provinceOptions: [],
      settleAmountFilter: 'IFNULL((select trd.item_count from tms_receivable_detail as trd, tms_receivable as tr where tr.status > 0 and tr.id = trd.receivable_id and trd.service_item_id = tssi.id), 0)',
      // 选中的单据ID
      id: null,
      eventType: '',
      // 合计结果
      totalAmount: 0,
      // 合计显示
      isShowTotal: false,
      // 下载物料制作申报审批表
      dialogDownloadVisible: false,
    }
  },
  created () {
    let _this = this;
    // 初始化主列表Table列
    _this.masterList.initTableColumn = [
      { prop: 'rowNumber', label: '序号', width: 80 },
      { prop: 'schemeNo', label: '方案编号', filterColumn: 'ts.project_no', width: 200 },
      { prop: 'schemeName', label: '方案名称', filterColumn: 'ts.name', width: 300 },
      { prop: 'schemeContent', label: '方案内容', filterColumn: 'ts.scheme_content', width: 300 },
      { prop: 'schemeStatusValue', label: '方案状态', filterColumn: 'ts.scheme_status', filterValue: 'schemeStatus', width: 110, filterArray: [{ label: '执行中', value: 1 }, { label: '执行完成', value: 2 }, { label: '终止执行', value: 3 }] },
      { prop: 'schemeReportDate', label: '填报时间', filterColumn: 'ts.report_date', width: 120, isBetween: true },
      { prop: 'schemeStartDate', label: '开始时间', filterColumn: 'ts.start_date', width: 150, isBetween: true },
      { prop: 'schemeEndDate', label: '结束时间', filterColumn: 'ts.end_date', width: 150, isBetween: true },
      { prop: 'provinceName', label: '活动省区', filterColumn: 'ts.province_names', width: 120 },
      { prop: 'cityName', label: '活动城市', filterColumn: 'ts.city_names', width: 120 },
      { prop: 'contractYear', label: '合同年份', filterColumn: 'tcs.year', width: 110 },
      { prop: 'contractName', label: '合同名称', filterColumn: 'tcs.name', width: 280 },
      { prop: 'contractNo', label: '合同编号', filterColumn: 'tcs.code', width: 160 },
      { prop: 'itemName', label: '项目名称', filterColumn: 'tssi.item_name', width: 120 },
      { prop: 'typeValue', label: '项目类型', filterColumn: 'tssi.type', filterValue: 'type', width: 120, filterArray: [{ label: '终端运维', value: 1 }, { label: '人员服务', value: 2 }, { label: '物资服务', value: 3 }, { label: '物料制作', value: 4 }, { label: '色彩终端', value: 5 }, { label: '品系宣介', value: 6 }, { label: '其他费用', value: 7 }, { label: '管理费', value: 99 }] },
      { prop: 'unit', label: '单位', filterColumn: 'tssi.unit', width: 100 },
      { prop: 'price', label: '单价', filterColumn: 'tssi.price', filterValue: 'price', width: 100, formatPrice: true },
      { prop: 'amount', label: '数量', filterColumn: 'tssi.amount', width: 100, allowSum: true },
      { prop: 'total', label: '金额', filterColumn: 'tssi.total', filterValue: 'total', width: 100, formatPrice: true, allowSum: true },
      { prop: 'settleCount', label: '结算数量', filterColumn: _this.settleAmountFilter, width: 120, allowSum: true }
    ]
    _this.loadProvinceData()
    // 默认主列表Table列
    _this.getInitTableColumns()
    _this.loadTableData()
  },
  methods: {
    // 请求数据
    requestData () {
      let _this = this;
      _this.isShowTotal = false
      loadSchemeServiceItemListDataApi(_this.masterList.tableQuery).then((response) => {
        const { data } = response;
        _this.handleData(data.list || [])
        _this.masterList.tableDataTotal = data.total || 0
      }).catch()
    },
    // 合计方法
    totalFun (fieldColumn, computedTotalObj) {
      let _this = this;
      _this.masterList.tableQuery.sumField = computedTotalObj.filterColumn
      sumSchemeServiceItemListDataApi(_this.masterList.tableQuery).then((response) => {
        _this.isShowTotal = true
        _this.totalAmount = response.data || 0
      }).catch()
    },
    // 初始活动省区下拉数据
    loadProvinceData () {
      let _this = this;
      _this.provinceOptions = []
      listAreaApi({ parentId: 1, isUserArea: 1 }).then((response) => {
        const { data } = response;
        data.forEach(item => {
          _this.provinceOptions.push({ label: item.name, data: item.id })
        })
      })
    },
    // 下载物料制作申报审批表
    handleDownloadDeclarationForm () {
      this.dialogDownloadVisible = !this.dialogDownloadVisible;
    },
    // 导出数据API
    exportByPage () {
      let _this = this;
      exportSchemeServiceItemListDataApi(_this.exportObj).then(response => {
        const { data } = response
        _this.$store.dispatch('message/settingExportSuccess', { exportSuccess: data.createFileResult, url: data.filePath })
      })
    }
  }
}
</script>
